<template>
  <div class="overlay">
    <div :style='mainContainerStyle.mainStyle.confirmationApproveWithChanges'>
      <div class="width_full" :style='mainContainerStyle.mainStyle.tableButton'>
        <h5 v-if='data.code === code.APPROVE_WITH_CHANGES'>{{ code.APPROVE_WITH_CHANGES_TEXT }}</h5>
        <h5 v-else-if='data.code === code.APPROVE_WITH_NO_CHANGES'>
          {{ code.NO_CHANGES_TEXT }}
        </h5>
      </div>
      <div v-if='data.headers && data.headers.length' class="" id='confirmationInnerDiv'>
        <div class="center center-parent">
          <div class="text-left inline-block" id='selectedOffersHeaderContainer'>
            <data-table :data='data.headers' :styles='tableStyles.offersListHeaderStyles'></data-table>
          </div>
          <div class="inline-block scrollable" :style='{width: `${count * scrollableWidth}rem`}'>
            <div class="inline-block" :style='{width: `${data.contents.length * scrollableChildrenWidth}rem`}'>
              <div
                class="text-left inline-block"
                v-for='data in data.contents'
                :style='{width: `${scrollableChildrenWidth}rem`}'>
                <data-table :data='data' :styles='tableStyles.offersListDataStyle'></data-table>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="margin_bottom width_full" :style='mainContainerStyle.mainStyle.tableButton'>
        <h5 v-if='data.code === code.APPROVE_WITH_CHANGES || data.code === code.APPROVE_WITH_NO_CHANGES || data.code === code.SET_ZONE'>
          {{ code.SUBMIT_TEXT }}
        </h5>
        <h5 v-else-if='data.code === code.REJECT_OFFER'>{{ code.REJECT_TEXT }}</h5>
        <button type="button" @click='cancel' class="primary-green-bg width_8">
          Cancel
        </button>
        <button type="button" @click='submit' class="primary-green-bg width_8">
          Submit
        </button>
      </div>
      <!-- <div v-for='value in data'>
        <div>
          <span>{{value.header}}</span>
          <span>:</span>
          <span>{{value.data}}</span>
        </div>
      </div> -->

    </div>

  </div>
</template>
<script>
import DataTable from 'src/components/shared/flexTables/DataTable'
import { tableStyles } from './tableStyles'
import { mainContainerStyle } from 'src/components/pop-up/mainContainerStyle'
import * as CODE from 'src/constants/Constants'

export default {
  data () {
    return {
      scrollableChildrenWidth: 20,
      scrollableWidth: 20,
      tableStyles: tableStyles,
      mainContainerStyle: mainContainerStyle,
      code: CODE,
      count: 1
    }
  },
  methods: {
    cancel () {
      window.eventBus.$emit('cancelConfirm', false)
    },
    submit () {
      if (this.data.code === this.code.APPROVE_WITH_CHANGES || this.data.code === this.code.APPROVE_WITH_NO_CHANGES) {
        window.eventBus.$emit('acceptConfirm', {code: 'approveWithChanges'})
      } else if (this.data.code === this.code.SET_ZONE) {
        window.eventBus.$emit('acceptConfirm', {code: 'setZone'})
      } else if (this.data.code === this.code.REJECT_OFFER) {
        window.eventBus.$emit('acceptConfirm', {code: 'rejectOffer'})
      }
    }
  },
  created () {
    if (this.data && this.data.contents) {
      if (this.data.contents.length >= 3) {
        this.count = 3
      } else if (this.data.contents.length === 2) {
        this.count = 2
      } else {
        this.count = 1
      }
    }
  },
  props: ['data', 'handleEvent'],
  components: {
    DataTable
  }
}
</script>
<style scoped>
  .main {
    background-color: #fff;
    /*width: 60%;
    text-align: center;
    padding: 2rem;
    margin-top: 5rem;*/
  }
  .center > * {
    vertical-align: top;
  }
  .center-parent {
    text-align: center;
  }
  .scrollable {
    text-align: center;
    width: 100%;
    overflow: auto;
  }
  .margin_bottom {
    margin-bottom: 2rem;
  }
  .overlay {
    height: 100vh;
    width: 100vw;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0, 0.3);
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// ConfirmationPopUp.vue?c4469e98